import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { VehiclesService } from '../list-vehicles.service';
import { Utils } from 'src/app/core/resources/utils';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Global } from 'src/app/core/resources/global';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { DateManager } from 'src/app/core/managers/date.manager';
import { KeyValue } from '@angular/common';
import { DriverLicenseCategory } from 'src/app/core/interfaces/driverLicenseCategory';
import { DriverLicensesDTO, User } from 'src/app/core/interfaces/user';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { Subscription } from 'rxjs';
import { VehicleConfig } from 'src/app/core/interfaces/vehicleConfig';
import { DriveStep } from 'driver.js';
import { OnboardingTourService } from 'src/app/core/services/onboarding-tour.service';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { AdminUsersService } from '../../admin-users/admin-users.service';
import { AuthService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-update-vehicle-fields',
  templateUrl: './update-vehicle-fields.component.html',
  styleUrls: ['./update-vehicle-fields.component.scss']
})
export class UpdateVehicleFieldsComponent implements OnInit {
  registrationDateFilter = DateManager.filter({ until: new Date() });
  vehicle: Vehicle;
  driver: User;
  permission = Permission;
  form: FormGroup = new FormGroup({});
  vehicleTypeControl = new FormControl();
  vehicleTypeSub: Subscription;
  optionsVehicleType: OptionsAutocomplete = {
    showAutocomplete: true
  };
  vehicleValidate = '';
  bodyworkTypeControl = new FormControl();
  bodyworkTypeSub: Subscription;
  optionsBodyworkType: OptionsAutocomplete = {
    title: 'Tipo de carrocería'
  };
  bodyworkValidate = '';
  fieldsRTM = [
    'validRTM.expirationDate',
  ]
  fieldsSOAT = [
    'validSOAT.expirationDate',
    'validSOAT.companyName',
    'validSOAT.companyNumber',
    'validSOAT.number'
  ];
  serviceTypes = [
    'Particular',
    'Público'
  ];
  readonly minimumManufacturingYear = 1900;
  readonly maximumManufacturingYear = new Date().getFullYear() + 1;
  constructor(
    public dialogRef: MatDialogRef<UpdateVehicleFieldsComponent>,
    @Inject(MAT_DIALOG_DATA) public paramsDialog: {
      vehicle?: Vehicle,
      driver?: User,
      type: 'SOAT' | 'RTM' | 'vehicle' | 'license',
      license?: DriverLicenseCategory,
      showOnboarding?: boolean
    },
    private snackBarService: SnackBarService,
    private spinner: NgxSpinnerService,
    private vehiclesService: VehiclesService,
    private permissionRole: PermissionRole,
    public utils: Utils,
    public global: Global,
    private onboardingTourService: OnboardingTourService,
    private adminUsersService: AdminUsersService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    if (this.paramsDialog && this.paramsDialog.type === 'license') {
      if (!this.paramsDialog.driver) {
        this.dialogRef.close();
        return;
      }
      this.driver = this.paramsDialog.driver;
    }
    else if (this.paramsDialog && ['SOAT', 'RTM', 'vehicle'].includes(this.paramsDialog.type)) {
      if (!this.paramsDialog.vehicle) {
        this.dialogRef.close();
        return;
      }
      this.vehicle = this.paramsDialog.vehicle;
    }
    else this.dialogRef.close();

    this.initForm();
    this.verifyFields();
    this.setSubscriptions();
  }

  ngAfterViewInit() {
    if (this.paramsDialog && this.paramsDialog.showOnboarding) this.startTour();
  }

  /**
  * @description Initializes the form
  */
  private initForm() {
    switch (this.paramsDialog.type) {
      case 'vehicle':
        this.form = new FormGroup({
          bodywork: new FormGroup({
            description: new FormControl(),
            code: new FormControl()
          }),
          brand: new FormGroup({
            description: new FormControl()
          }),
          manufacturingYear: new FormControl('', [
            Validators.pattern(/^\d{4}$/),
            Validators.min(this.minimumManufacturingYear),
            Validators.max(this.maximumManufacturingYear)
          ]),
          axles: new FormControl(),
          color: new FormControl(),
          fuelType: new FormGroup({
            description: new FormControl()
          }),
          chassisId: new FormControl(),
          motorId: new FormControl(),
          line: new FormGroup({
            description: new FormControl()
          }),
          vehicleType: new FormGroup({
            name: new FormControl()
          }),
          registrationDate: new FormControl(),
          emptyWeight: new FormControl(),
          grossWeight: new FormControl(),
          capacity: new FormControl(),
          serviceType: new FormControl()
        });
        break;
      case 'RTM':
        this.form.addControl('validRTM', new FormGroup({
          expirationDate: new FormControl()
        }));
        break;
      case 'SOAT':
        this.form.addControl('validSOAT', new FormGroup({
          expirationDate: new FormControl(),
          companyName: new FormControl(),
          companyNumber: new FormControl(),
          number: new FormControl(),
        }));
        break;
      case 'license':
        this.form = new FormGroup({
          category: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
          numberLicense: new FormControl('', Validators.required),
          restrictions: new FormControl(),
          expeditionDate: new FormControl('', Validators.required),
          expirationDate: new FormControl('', Validators.required),
        });
        break;
    }
  }

  startTour(): void {
    const steps: DriveStep[] = [
      {
        element: '#serviceTypeStep',
        popover: {
          title: 'Tipo de servicio',
          description: 'Debes seleccionar el tipo de servicio en el desplegable y luego darle click al botón "Guardar"',
          side: 'bottom'
        },
        disableActiveInteraction: true,
      },
    ];
    if (!this.onboardingTourService.driverInstance) this.onboardingTourService.setDriverInstanceConfig();
    this.onboardingTourService.setSteps(steps);
    this.onboardingTourService.startTour();
  }

  /**
  * @description Verifies the vehicle fields to fill the form
  */
  private verifyFields() {
    switch (this.paramsDialog.type) {
      case 'vehicle':
        [...this.global.vehicleEditableFields, 'vehicleType.name', 'bodywork.description', 'bodywork.code'].forEach(field => {
          let value = this.utils.getNestedValue(this.vehicle, field);
          if (this.utils.isDefined(value)) {
            this.form.get(field).setValue(value);
            if (!this.canOverwriteInfo) {
              this.form.get(field).disable();
              if (field === 'vehicleType.name') this.vehicleValidate = 'disable';
              if (field === 'bodywork.description') this.bodyworkValidate = 'disable';
            }
          }
        });
        this.optionsVehicleType['initialValue'] = this.utils.getNestedValue(this.vehicle, 'vehicleType.name') ? this.utils.getNestedValue(this.vehicle, 'vehicleType.name') : '';
        this.optionsVehicleType = { ...this.optionsVehicleType };
        this.optionsBodyworkType['initialValue'] = this.utils.getNestedValue(this.vehicle, 'bodywork.description')
          ? this.utils.getNestedValue(this.vehicle, 'bodywork.description') : '';
        this.optionsBodyworkType['initialVehicleTypeName'] = this.utils.getNestedValue(this.vehicle, 'vehicleType.name')
          ? this.utils.getNestedValue(this.vehicle, 'vehicleType.name') : '';
        this.optionsBodyworkType = { ...this.optionsBodyworkType };
        if (this.vehicle.registrationDate) {
          this.form.get('registrationDate').setValue(DateManager.stringToDate(this.vehicle.registrationDate));
          !this.canOverwriteInfo && this.form.get('registrationDate').disable();
        }
        if (this.vehicle.serviceType) {
          this.form.get('serviceType').setValue(this.vehicle.serviceType);
        }
        break;
      case 'RTM':
        this.fieldsRTM.forEach(field => {
          let value = this.utils.getNestedValue(this.vehicle, field);
          if (this.utils.isDefined(value)) {
            this.form.get(field).setValue(field.includes('.expirationDate') ? DateManager.stringToDate(value) : value);
            if (!this.canOverwriteInfo) this.form.get(field).disable();
          }
        });
        break;
      case 'SOAT':
        this.fieldsSOAT.forEach(field => {
          let value = this.utils.getNestedValue(this.vehicle, field);
          if (this.utils.isDefined(value)) {
            this.form.get(field).setValue(field.includes('.expirationDate') ? DateManager.stringToDate(value) : value);
            if (!this.canOverwriteInfo) this.form.get(field).disable();
          }
        });
        break;
      case 'license':
        if (this.paramsDialog.license) {
          Object.keys(this.paramsDialog.license).forEach(key => {
            const value = ['expeditionDate', 'expirationDate'].includes(key)
              ? DateManager.stringToDate(this.paramsDialog.license[key], 'YYYY-MM-DDTHH:mm:ss')
              : this.paramsDialog.license[key];
            if (this.form.get(key)) this.form.get(key).setValue(value);
          });
        }
        break;
    }
  }

  private setSubscriptions() {
    if (this.paramsDialog.type === 'vehicle')
      this.vehicleTypeSub = this.vehicleTypeControl.valueChanges.subscribe(value => {
        this.form.get('vehicleType.name').setValue(value && value.name ? value.name : '');
        if (value) {
          this.optionsBodyworkType['initialVehicleTypeId'] = value.id ? value.id : '';
          this.optionsBodyworkType['initialVehicleTypeName'] = null;
          this.optionsBodyworkType['initialValue'] = '';
          this.optionsBodyworkType = { ...this.optionsBodyworkType };
          this.form.get('bodywork.description').setValue('');
          this.form.get('bodywork.code').setValue('');
        }
      })
    this.bodyworkTypeSub = this.bodyworkTypeControl.valueChanges.subscribe(value => {
      this.form.get('bodywork.description').setValue(value && value.name ? value.name : '');
      this.form.get('bodywork.code').setValue(value && value.id ? value.id : '');
    });
  }

  /**
  * @description Organizes the ngFor by keyvalue in the original order of the object.keys
  */
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  isVisibleField(field: string): boolean {
    const fieldsToValidate = ['emptyWeight', 'grossWeight', 'capacity'];
    if (!fieldsToValidate.includes(field)) return true;
    const hasTransportServicesCompany = !!(this.authService && this.authService.hasTransportServicesCompany);
    return hasTransportServicesCompany;
  }

  public onManufacturingYearKeyPress(event: KeyboardEvent): void {
    const isNumericKey = /^\d$/.test(event.key);
    if (!isNumericKey) event.preventDefault();
  }

  public getManufacturingYearErrorMessage(): string {
    const control = this.form && this.form.get('manufacturingYear');
    if (!control || !control.errors) return '';
    if (control.errors.pattern) return 'Debe tener exactamente 4 dígitos (YYYY)';
    if (control.errors.min) return `El año mínimo permitido es ${this.minimumManufacturingYear}`;
    if (control.errors.max) return `El año máximo permitido es ${this.maximumManufacturingYear}`;
    return '';
  }


  private calculateActiveStatus(expirationDate: Date): boolean {
    if (!expirationDate) return false;
    const today = DateManager.setStartOfDay(new Date());
    const expiration = DateManager.setStartOfDay(expirationDate);
    if (!today || !expiration) return false;
    const isExpired = DateManager.isSameOrBefore(expiration, today, 'days');
    if (isExpired === null) return false;
    return !isExpired;
  }

  /**
  * @description Creates the body to update the vehicle by the form's changes
  */
  onSubmit() {
    if (this.paramsDialog.type === 'license') {
      if (this.utils.errorMessagesCustomized(this.form.get("category"), "Categoría", 2, 2)) return;
      if (this.utils.errorMessagesCustomized(this.form.get("numberLicense"), "N° de licencia")) return;
      if (this.utils.errorMessagesCustomized(this.form.get("expeditionDate"), "Fecha de expedición")) return;
      if (this.utils.errorMessagesCustomized(this.form.get("expirationDate"), "Fecha de expiración")) return;

      let body: DriverLicensesDTO = {
        driverLicense: {
          active: false
        },
        driverLicenseCategory: [...(this.driver && this.driver.driverLicenseCategory ? this.driver.driverLicenseCategory : [])]
      };
      let license = this.form.getRawValue();
      license.category = license.category.toUpperCase();
      license.expeditionDate = `${DateManager.dateToString(license.expeditionDate, 'YYYY-MM-DDTHH:mm:ss')}Z`;
      license.expirationDate = `${DateManager.dateToString(license.expirationDate, 'YYYY-MM-DDTHH:mm:ss')}Z`;
      if (!license.restrictions) delete license.restrictions;
      const previousLicense = this.paramsDialog && this.paramsDialog.license ? this.paramsDialog.license : null;
      const expirationDateObj = this.form.get('expirationDate').value;
      license.active = this.calculateActiveStatus(expirationDateObj);

      const index = body.driverLicenseCategory.findIndex(vehicleLicense => previousLicense && vehicleLicense.category === previousLicense.category);
      if (index !== -1) body.driverLicenseCategory[index] = { ...license };
      else body.driverLicenseCategory.push(license);

      if (this.adminUsersService.checkDuplicatedLicenses(body.driverLicenseCategory))
        return this.snackBarService.openSnackBar(FormMessages.DUPLICATED_LICENSES, undefined, "alert");

      const everyLicenseExpired: boolean = body.driverLicenseCategory.every((licenseItem: DriverLicenseCategory) => {
        if (!licenseItem.expirationDate) {
          licenseItem.active = false;
          return true;
        }
        let licenseExpirationDate = DateManager.stringToDate(licenseItem.expirationDate, 'YYYY-MM-DDTHH:mm:ss');
        licenseItem.active = this.calculateActiveStatus(licenseExpirationDate);
        return !licenseItem.active;
      });
      body.driverLicense = {
        active: !everyLicenseExpired,
        description: everyLicenseExpired ? 'Licencia de conducción no activa' : 'Licencia de conducción activa'
      };
      return this.updateLicenses(this.driver.information.document, body);
    }
    let body = this.utils.clone(this.vehicle);
    switch (this.paramsDialog.type) {
      case 'vehicle':
        const manufacturingYearControl = this.form.get('manufacturingYear');
        if (manufacturingYearControl && manufacturingYearControl.enabled && manufacturingYearControl.value && manufacturingYearControl.invalid) {
          const errorMessage = this.getManufacturingYearErrorMessage() || 'Año modelo inválido';
          this.snackBarService.openSnackBar(errorMessage, undefined, 'alert');
          return;
        }
        [...this.global.vehicleEditableFields, 'vehicleType.name', 'bodywork.description', 'bodywork.code', 'registrationDate', 'serviceType'].forEach(field => {
          const control = this.form.get(field);
          const emptyFields = ['bodywork.description', 'bodywork.code'];
          if (control && (control.value || emptyFields.includes(field)) && control.enabled) {
            if (field.includes(".")) {
              if (!body[field.split('.')[0]]) body[field.split('.')[0]] = {};
              body[field.split('.')[0]][field.split('.')[1]] = control.value
            }
            else if (field === 'registrationDate') body[field] = DateManager.dateToString(control.value);
            else if (['emptyWeight', 'grossWeight', 'capacity'].includes(field)) body[field] = Number(control.value);
            else if (field === 'manufacturingYear') body[field] = String(control.value).trim();
            else body[field] = control.value;
          }
        });
        break;
      case 'RTM':
        if (!body.validRTM) body['validRTM'] = {};
        const expirationDateRTM = this.form.get(`validRTM.expirationDate`);
        let dateToUseRTM: Date = null;

        if (expirationDateRTM && expirationDateRTM.value && expirationDateRTM.enabled) {
          dateToUseRTM = expirationDateRTM.value;
          body['validRTM'].expirationDate = DateManager.dateToString(dateToUseRTM, 'YYYY-MM-DDT00:00:00-05');
        }
        else if (expirationDateRTM && expirationDateRTM.value) dateToUseRTM = expirationDateRTM.value;
        else if (body.validRTM && body.validRTM.expirationDate) dateToUseRTM = DateManager.stringToDate(body.validRTM.expirationDate);

        if (dateToUseRTM) {
          const isActive = this.calculateActiveStatus(dateToUseRTM);
          body['validRTM'].active = isActive;
          body['validRTM'].description = isActive ? 'Active' : 'Inactive';
        }
        break;
      case 'SOAT':
        if (!body.validSOAT) body['validSOAT'] = {};
        const expirationDate = this.form.get(`validSOAT.expirationDate`);
        let dateToUseSOAT: Date = null;
        if (expirationDate && expirationDate.value && expirationDate.enabled) {
          dateToUseSOAT = expirationDate.value;
          body['validSOAT'].expirationDate = DateManager.dateToString(dateToUseSOAT, 'YYYY-MM-DDT00:00:00-05');
        }
        else if (expirationDate && expirationDate.value) dateToUseSOAT = expirationDate.value;
        else if (body.validSOAT && body.validSOAT.expirationDate) dateToUseSOAT = DateManager.stringToDate(body.validSOAT.expirationDate);

        if (dateToUseSOAT) {
          const isActive = this.calculateActiveStatus(dateToUseSOAT);
          body['validSOAT'].active = isActive;
          body['validSOAT'].description = isActive ? 'Active' : 'Inactive';
        }

        ['companyName', 'companyNumber', 'number'].forEach(field => {
          const value = this.form.get(`validSOAT.${field}`);
          if (value && value.value && value.enabled)
            body['validSOAT'][field] = value.value;
        });
        break;
    }
    this.getVehicleConfig(body);
  }

  /**
  * @param {string} document is the driver's document
  * @param {DriverLicensesDTO} body is the vehicle's licenses
  * @param {string} role is the user's role
  * @description updates the vehicle fields and closes the dialog
  */
  public updateLicenses(document: string, body: DriverLicensesDTO) {
    this.spinner.show();
    this.vehiclesService.updateUserLicenses(document, body, 'Driver').subscribe(
      () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_SUCCESS);
        this.dialogRef.close({ state: true });
      },
      () => {
        this.spinner.hide();
        this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      },
    );
  }

  /**
  * @param {Vehicle} body is the vehicle updated
  * @description updates the vehicle fields and closes the dialog
  */
  public async updateVehicleFields(body: Vehicle): Promise<boolean> {
    try {
      await this.vehiclesService.updateVehicleFields(body).toPromise();
      return true;
    } catch (error) {
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
      return false;
    }
  }

  /**
  * @returns {boolean} Returns true if the user the "editFieldsRUNT" permission, otherwise false
  * @description Verifies if the user has the "editFieldsRUNT" permission
  */
  private get canOverwriteInfo(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.administration.module,
      this.permission.administration.editFieldsRUNT
    );
  }

  private async getVehicleConfig(vehicle: Vehicle) {
    this.spinner.show();
    try {
      let response = await this.vehiclesService.getVehicleConfig(vehicle.axles).toPromise();
      this.setVehicleConfig(response, vehicle);
    } catch (error) { console.error(error) };
    let success = await this.updateVehicleFields(vehicle);
    if (success) await this.validateVehicleToRNDC(vehicle);
    this.spinner.hide();
  }

  setVehicleConfig(response: VehicleConfig[], vehicle: Vehicle) {
    if (response.length > 0) {
      let vehicleTypeName: string = vehicle.vehicleType.name.toLowerCase();

      if (!this.utils.isEmpty(vehicleTypeName) && vehicleTypeName === "camion") {
        vehicleTypeName = "camion rigido";
      }

      const listConfig: VehicleConfig[] = response.filter(config => config.name.toLowerCase().includes(vehicleTypeName));
      if (listConfig.length > 0) {
        listConfig.sort((a: VehicleConfig, b: VehicleConfig) => {
          return a.code.localeCompare(b.code);
        });
        vehicle.vehicleType.configuration = {
          code: listConfig[0].code,
          description: listConfig[0].name
        }
      }
    }
  }

  async validateVehicleToRNDC(vehicle: Vehicle) {
    try {
      await this.vehiclesService.rndcVehicleCreation(vehicle.id).toPromise();
      this.snackBarService.openSnackBar(ServiceMessages.VEHICLE_CHANGED_SUCCESS);
      this.dialogRef.close({ state: true });
    } catch (error) {
      this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
    }
  }

  ngOnDestroy() {
    if (this.bodyworkTypeSub) this.bodyworkTypeSub.unsubscribe();
    if (this.vehicleTypeSub) this.vehicleTypeSub.unsubscribe();
  }

}
